var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.source === '-1' ||
      _vm.source === '0' ||
      _vm.source === '2' ||
      _vm.source === '3' ||
      _vm.source === '10' ||
      _vm.source === '11' ||
      _vm.source === '12' ||
      _vm.source === '13' ||
      _vm.source === '14' ||
      _vm.source === '15' ||
      _vm.source === '16' ||
      _vm.source === '17' ||
      _vm.source === '18' ||
      _vm.source === '19' ||
      _vm.source === '20'
  )?_c('noticeViewAllList',{attrs:{"currBreadCrumb":_vm.currBreadCrumb,"source":_vm.source,"activeName":_vm.activeName,"interfaceType":_vm.interfaceType,"activeIndex":_vm.activeIndex}}):(
    _vm.source === '1' || _vm.source === '4' || _vm.source === '5' || _vm.source === '6'
  )?_c('market-dynamic-and-price-info-list',{attrs:{"source":_vm.source,"curr-bread-crumb":_vm.currBreadCrumb,"interfaceTypeValue":_vm.interfaceType,"activeIndex":_vm.activeIndex}}):(
    _vm.source === _vm.announcementPageSource.overseasZone ||
      _vm.source === _vm.announcementPageSource.JCCG ||
      _vm.source === _vm.announcementPageSource.JGFA ||
      _vm.source === _vm.announcementPageSource.JCKJXY ||
      _vm.source === _vm.announcementPageSource.WZJCML ||
      _vm.source === _vm.announcementPageSource.CGGLZD ||
      _vm.source === _vm.announcementPageSource.SFWB ||
      _vm.source === _vm.announcementPageSource.NMQYXX ||
      _vm.source === _vm.announcementPageSource.HJQK ||
      _vm.source === _vm.announcementPageSource.ZCFG ||
      _vm.source === _vm.announcementPageSource.ZDLC ||
      _vm.source === _vm.announcementPageSource.HTFB ||
      _vm.source === _vm.announcementPageSource.ZSGL ||
      _vm.source === _vm.announcementPageSource.GLTX ||
      _vm.source === _vm.announcementPageSource.HYWZ ||
      _vm.source === _vm.announcementPageSource.HYXW ||
      _vm.source === _vm.announcementPageSource.SCHQ ||
      _vm.source === _vm.announcementPageSource.JGXX ||
      _vm.source === _vm.announcementPageSource.FXBG ||
      _vm.source === _vm.announcementPageSource.GYLGLBZJLXX ||
      _vm.source === _vm.announcementPageSource.JCZJCYMD
  )?_c('listNew',{attrs:{"currBreadCrumb":_vm.currBreadCrumb,"callInterface":_vm.callInterface1,"source":_vm.source,"activeIndex":_vm.activeIndex}}):(_vm.source === _vm.announcementPageSource.JTGYSML)?_c('supList',{attrs:{"currBreadCrumb":_vm.currBreadCrumb,"callInterface":_vm.callInterface2,"source":_vm.source}}):(_vm.source === _vm.announcementPageSource.exchangeForum)?_c('exchangeForum',{attrs:{"curr-bread-crumb":_vm.currBreadCrumb,"activeIndex":_vm.activeIndex}}):_c('list',{attrs:{"currBreadCrumb":_vm.currBreadCrumb,"callInterface":_vm.callInterface,"source":_vm.source}})}
var staticRenderFns = []

export { render, staticRenderFns }